var map = {
	"./1.jpg": 83,
	"./2.jpg": 636,
	"./3.jpg": 681,
	"./4.jpg": 994,
	"./5.jpg": 831,
	"./6.jpg": 80,
	"./7.jpg": 597,
	"./8.jpg": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 455;